import { deClientPortalAssetDetailsCommon } from './Assets/AssetDetails'
import { deClientPortalAssetListPages } from './Assets/AssetList'

export const deClientPortalAssetsCommon = {
    assets: {
        ...deClientPortalAssetListPages,
        ...deClientPortalAssetDetailsCommon,
    },
}
